<template>
  <div>
    <h3>카카오 로그인 이후 페이지</h3>
    <p v-text="codes">codes</p>
    <div>email : <p v-text="form.email">codes</p></div>
    <div>id : <p v-text="form.id">codes</p></div>
  </div>
</template>

<script>
import axios from 'axios'
//import * as KakaoUtil from '@/utils/Kakao.js'

export default {
  created() {
    this.create();
  },
  name: 'KakaoLoginSample',
  data() {
    return {
      codes: "",
      form: {
        email: "",
        id: ""
      }
    }
  },
  methods:{
    create() {
      this.codes = this.$route.query.code;
      this.getToken();
    },
    getToken() {
      console.log("codes : " + this.codes);
      axios
        .get("http://localhost:8080/test/kakaoLogin?auth_code=" + this.codes)
        .then((res) => {
          this.form.email = res.data.email;
          this.form.id = res.data.id;
          if(this.form.id == undefined) {
            alert("올바르지 못한 접근입니다.");
          } else {
            //this.login()
            alert("접근 성공!");

            const redirect = "/";

            this.signinKakao(this.form)
            .then(() => {
              if(redirect == ''){
                this.$router.replace({
                  path: '/'
                })
              }

              this.$router.replace({
                path: redirect
              })

            })
            .catch(() => {
              this.$alert("알림", "가입하지 않은 아이디이거나, 잘못된 비밀번호입니다.");
            })
            
          }
        });
    },
    login() {
      // axios.post("http://localhost:8080/login", this.form).then((rest) => {
      //   if(res.data != null) {

      //   }
      // });
    }

  }
}
</script>